import { render, staticRenderFns } from "./CompMailbox.vue?vue&type=template&id=7001c340"
import script from "./CompMailbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CompMailbox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports